export default {
  'component.tagSelect.expand': 'Expandir',
  'component.tagSelect.collapse': 'Collapsar',
  'component.tagSelect.all': 'Todos',

  'component.notifications.operationCompleted': 'Operación completada',
  'component.notifications.successfully': 'satisfactoriamente',
  'component.notifications.operationRejected': 'Operación rechazada',
  'component.notifications.andUnderObservation': 'y en observación',
  'component.notifications.completeInformation': 'Completar información',
  'component.notifications.attachDocument': 'Adjuntar documento',
  'component.notifications.confirmDelete': '¿Seguro de querer eliminar este elemento?',
  'component.notifications.confirmReject': 'Motivo del rechazo',
  'component.notifications.confirmApprove': 'Observaciones aprobación',

  'component.filters.SearchInput.placeholder': 'Filtra escribiendo una palabra',
  /* Ace form fields — edit-mode defaults (hidden in details/view-only, like DatePicker). */
  'component.aceInput.placeholder.text': 'Escribir...',
  'component.aceInput.placeholder.number': 'Ingresar número',
  'component.aceInput.placeholder.select': 'Seleccionar',
  'component.results': 'resultados',
  'component.errorBoundary.message': 'Something went wrong.',
  'component.errorBoundary.title': 'Oops! Algo salió mal',
  'component.errorBoundary.subtitle':
    'Lo sentimos, se ha producido un error inesperado. Por favor, intenta refrescar la página.',
  'component.errorBoundary.refresh': 'Refrescar página',
  'component.remote.search.placeholder': 'Introduzca al menos un caracter para buscar',

  'component.user.profilePhoto': 'foto de perfil',
  'component.user.userProfilePhoto': 'Foto de perfil de usuario',
  'component.user.userProfile': 'Perfil de usuario',
  'component.user.profile': 'perfil',
  'component.user.loadingProfilePhoto': 'Cargando foto de perfil',
  'component.user.nameProfilePhoto': 'Foto de perfil de {name}',
  'component.user.userIdProfilePhoto': 'Foto de perfil del usuario {id}',
  'component.user.nameProfile': 'Perfil de {name}',
  'component.user.nameInitials': 'Iniciales del Usuario',
  'component.user.defaultAvatar': 'Avatar del Usuario',

  // ─── EntitySelector — reusable multi-picker ──────────────────────────────
  'entitySelector.connection.empty': 'Vincula una conexión para que el agente pueda usarla',
  'entitySelector.connection.emptyHint': 'Vincula una conexión para que el agente pueda usarla',
  'entitySelector.connection.add': 'Agregar conexión',
  'entitySelector.connection.create': 'Crear nueva conexión',
  'entitySelector.connection.search': 'Buscar conexiones…',
  'entitySelector.connection.noResults': 'No se encontraron conexiones',

  'entitySelector.skill.empty': 'Vincula una habilidad para ampliar lo que sabe hacer',
  'entitySelector.skill.emptyHint': 'Vincula una habilidad para ampliar lo que sabe hacer',
  'entitySelector.skill.add': 'Agregar habilidad',
  'entitySelector.skill.create': 'Crear nueva habilidad',
  'entitySelector.skill.search': 'Buscar habilidades…',
  'entitySelector.skill.noResults': 'No se encontraron habilidades',

  'entitySelector.vector.empty': 'Vincula un vector para darle conocimiento que pueda consultar',
  'entitySelector.vector.emptyHint':
    'Vincula un vector para darle conocimiento que pueda consultar',
  'entitySelector.vector.add': 'Agregar vector',
  'entitySelector.vector.create': 'Crear nuevo vector',
  'entitySelector.vector.search': 'Buscar vectores…',
  'entitySelector.vector.noResults': 'No se encontraron vectores',

  'entitySelector.memory.empty': 'Vincula una memoria para que el agente recuerde contexto',
  'entitySelector.memory.emptyHint': 'Vincula una memoria para que el agente recuerde contexto',
  'entitySelector.memory.add': 'Agregar memoria',
  'entitySelector.memory.create': 'Crear nueva memoria',
  'entitySelector.memory.search': 'Buscar memorias…',
  'entitySelector.memory.noResults': 'No se encontraron memorias',

  'entitySelector.aiTool.empty': 'Habilita una herramienta integrada para el agente',
  'entitySelector.aiTool.emptyHint': 'Habilita una herramienta integrada para el agente',
  'entitySelector.aiTool.add': 'Agregar herramienta',
  'entitySelector.aiTool.create': 'Crear nueva herramienta',
  'entitySelector.aiTool.search': 'Buscar herramientas…',
  'entitySelector.aiTool.noResults': 'No se encontraron herramientas',

  'entitySelector.appAuthMode.empty': 'Elige el modo de autenticación',
  'entitySelector.appAuthMode.emptyHint': 'Nativa o Pública',
  'entitySelector.appAuthMode.add': 'Elegir modo',
  'entitySelector.appAuthMode.create': 'Crear modo de autenticación',
  'entitySelector.appAuthMode.search': 'Buscar modos…',
  'entitySelector.appAuthMode.noResults': 'No se encontraron modos',

  'entitySelector.aiAgentTeam.empty': 'Asigna este agente a un equipo administrativo',
  'entitySelector.aiAgentTeam.emptyHint': 'Asigna este agente a un equipo administrativo',
  'entitySelector.aiAgentTeam.add': 'Asignar equipo',
  'entitySelector.aiAgentTeam.create': 'Crear nuevo equipo',
  'entitySelector.aiAgentTeam.search': 'Buscar equipos…',
  'entitySelector.aiAgentTeam.noResults': 'No se encontraron equipos',

  'entitySelector.aiSkillGroup.empty': 'Agrupa esta skill en una carpeta',
  'entitySelector.aiSkillGroup.emptyHint': 'Agrupa esta skill en una carpeta',
  'entitySelector.aiSkillGroup.add': 'Asignar grupo',
  'entitySelector.aiSkillGroup.create': 'Crear nuevo grupo',
  'entitySelector.aiSkillGroup.search': 'Buscar grupos…',
  'entitySelector.aiSkillGroup.noResults': 'No se encontraron grupos',

  'entitySelector.customListGroup.empty': 'Asigna esta lista a un grupo',
  'entitySelector.customListGroup.emptyHint': 'Asigna esta lista a un grupo',
  'entitySelector.customListGroup.add': 'Asignar grupo',
  'entitySelector.customListGroup.create': 'Crear nuevo grupo',
  'entitySelector.customListGroup.search': 'Buscar grupos de listas…',
  'entitySelector.customListGroup.noResults': 'No se encontraron grupos',

  'entitySelector.documentFolder.empty': 'Elige la carpeta de destino',
  'entitySelector.documentFolder.emptyHint': 'Elige la carpeta de destino',
  'entitySelector.documentFolder.add': 'Elegir carpeta',
  'entitySelector.documentFolder.create': 'Nueva carpeta',
  'entitySelector.documentFolder.search': 'Buscar carpetas…',
  'entitySelector.documentFolder.noResults': 'No se encontraron carpetas',

  'entitySelector.processGroup.empty': 'Asigna este proceso a un grupo',
  'entitySelector.processGroup.emptyHint': 'Asigna este proceso a un grupo',
  'entitySelector.processGroup.add': 'Asignar grupo',
  'entitySelector.processGroup.create': 'Crear nuevo grupo',
  'entitySelector.processGroup.search': 'Buscar grupos de procesos…',
  'entitySelector.processGroup.noResults': 'No se encontraron grupos',

  'entitySelector.connectionGroup.empty': 'Asigna esta conexión a un grupo',
  'entitySelector.connectionGroup.emptyHint': 'Asigna esta conexión a un grupo',
  'entitySelector.connectionGroup.add': 'Asignar grupo',
  'entitySelector.connectionGroup.create': 'Crear nuevo grupo',
  'entitySelector.connectionGroup.search': 'Buscar grupos de conexiones…',
  'entitySelector.connectionGroup.noResults': 'No se encontraron grupos',

  'entitySelector.dynamicEntityGroup.empty': 'Asigna esta entidad a un grupo',
  'entitySelector.dynamicEntityGroup.emptyHint': 'Asigna esta entidad a un grupo',
  'entitySelector.dynamicEntityGroup.add': 'Asignar grupo',
  'entitySelector.dynamicEntityGroup.create': 'Crear nuevo grupo',
  'entitySelector.dynamicEntityGroup.search': 'Buscar grupos de entidades…',
  'entitySelector.dynamicEntityGroup.noResults': 'No se encontraron grupos',

  'entitySelector.process.empty': 'Vincula un proceso a este permiso',
  'entitySelector.process.emptyHint': 'Vincula un proceso a este permiso',
  'entitySelector.process.add': 'Agregar proceso',
  'entitySelector.process.create': 'Crear nuevo proceso',
  'entitySelector.process.search': 'Buscar procesos…',
  'entitySelector.process.noResults': 'No se encontraron procesos',

  'entitySelector.list.empty': 'Vincula una lista a este permiso',
  'entitySelector.list.emptyHint': 'Vincula una lista a este permiso',
  'entitySelector.list.add': 'Agregar lista',
  'entitySelector.list.create': 'Crear nueva lista',
  'entitySelector.list.search': 'Buscar listas…',
  'entitySelector.list.noResults': 'No se encontraron listas',

  'entitySelector.report.empty': 'Vincula un reporte a este permiso',
  'entitySelector.report.emptyHint': 'Vincula un reporte a este permiso',
  'entitySelector.report.add': 'Agregar reporte',
  'entitySelector.report.create': 'Crear nuevo reporte',
  'entitySelector.report.search': 'Buscar reportes…',
  'entitySelector.report.noResults': 'No se encontraron reportes',

  'entitySelector.entity.empty': 'Vincula una entidad a este permiso',
  'entitySelector.entity.emptyHint': 'Vincula una entidad a este permiso',
  'entitySelector.entity.add': 'Agregar entidad',
  'entitySelector.entity.create': 'Crear nueva entidad',
  'entitySelector.entity.search': 'Buscar entidades…',
  'entitySelector.entity.noResults': 'No se encontraron entidades',

  'entitySelector.aiAgent.empty': 'Vincula un agente IA a este permiso',
  'entitySelector.aiAgent.emptyHint': 'Vincula un agente IA a este permiso',
  'entitySelector.aiAgent.add': 'Agregar agente IA',
  'entitySelector.aiAgent.create': 'Crear nuevo agente IA',
  'entitySelector.aiAgent.search': 'Buscar agentes IA…',
  'entitySelector.aiAgent.noResults': 'No se encontraron agentes IA',

  'entitySelector.user.empty': 'Vincula un usuario',
  'entitySelector.user.emptyHint': 'Vincula un usuario',
  'entitySelector.user.add': 'Agregar usuario',
  'entitySelector.user.create': 'Crear nuevo usuario',
  'entitySelector.user.search': 'Buscar usuarios…',
  'entitySelector.user.noResults': 'No se encontraron usuarios',

  'entitySelector.userTask.empty': 'Vincula una de tus tareas',
  'entitySelector.userTask.emptyHint': 'Vincula una de tus tareas',
  'entitySelector.userTask.add': 'Vincular tarea',
  'entitySelector.userTask.create': 'Crear nueva tarea',
  'entitySelector.userTask.search': 'Buscar tareas…',
  'entitySelector.userTask.noResults': 'No se encontraron tareas',

  'entitySelector.userGroup.empty': 'Vincula un grupo',
  'entitySelector.userGroup.emptyHint': 'Vincula un grupo',
  'entitySelector.userGroup.add': 'Agregar grupo',
  'entitySelector.userGroup.create': 'Crear nuevo grupo',
  'entitySelector.userGroup.search': 'Buscar grupos…',
  'entitySelector.userGroup.noResults': 'No se encontraron grupos',

  'entitySelector.position.empty': 'Vincula una posición',
  'entitySelector.position.emptyHint': 'Vincula una posición',
  'entitySelector.position.add': 'Agregar posición',
  'entitySelector.position.create': 'Crear nueva posición',
  'entitySelector.position.search': 'Buscar posiciones…',
  'entitySelector.position.noResults': 'No se encontraron posiciones',

  'entitySelector.area.empty': 'Vincula un área',
  'entitySelector.area.emptyHint': 'Vincula un área',
  'entitySelector.area.add': 'Agregar área',
  'entitySelector.area.create': 'Crear nueva área',
  'entitySelector.area.search': 'Buscar áreas…',
  'entitySelector.area.noResults': 'No se encontraron áreas',

  'entitySelector.generic.empty': 'Aún no hay elementos vinculados',
  'entitySelector.generic.emptyHint': 'Aún no hay elementos vinculados',
  'entitySelector.generic.add': 'Agregar',
  'entitySelector.generic.change': 'Cambiar',
  'entitySelector.generic.create': 'Crear nuevo',
  'entitySelector.generic.search': 'Buscar…',
  'entitySelector.generic.noResults': 'Sin resultados',
  'entitySelector.generic.notSupported': 'La creación rápida no está disponible aquí',
  'entitySelector.created.added': 'Creado y agregado a la selección',
  'entitySelector.created.refreshed': 'Lista actualizada con el nuevo elemento',

  // ─── CollaboratorsDrawer — compartido entre los 4 dominios que siguen ──
  //     la guía UX "AccessControl vs Collaborator" (DynamicEntity,
  //     CustomList, App, AIAgent).
  'collaboratorsDrawer.title': 'Colaboradores',
  'collaboratorsDrawer.addSection': 'Agregar colaboradores',
  'collaboratorsDrawer.selectUsers': 'Seleccionar usuarios',
  'collaboratorsDrawer.usersRequired': 'Selecciona al menos un usuario',
  'collaboratorsDrawer.add': 'Agregar colaborador',
  'collaboratorsDrawer.current': 'Colaboradores actuales',
  'collaboratorsDrawer.empty': 'Aún no hay colaboradores',
  'collaboratorsDrawer.remove.content': '¿Seguro que deseas quitar a {userName} como colaborador?',
};
